/* eslint-disable */
export default {
  infoMessageMins: '{delayTime} 分鐘後自動儲存記錄...',
  infoMessageMin: '{delayTime} 分鐘後自動儲存記錄...',
  infoMessageSecs: '{delayTime} 秒鐘後自動儲存記錄...',
  infoMessageSec: '{delayTime} 秒鐘後自動儲存記錄...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
